// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1p5ku","head":"Table_head__3976L","col":"Table_col__2Tov1"};